import styled from 'styled-components';
import { Colors, FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';

export const ModalRoot = styled.div`
    width: 100vw;
    height: 100%;
    min-height: 100%;
    align-self: stretch;
    background: ${Colors.geoWhite100};
    box-sizing: border-box;
    padding: 32px 48px 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (max-width: ${LayoutConst.screen.md}px) {
        padding: 48px 24px 0;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        padding: 40px 16px 0;
    }
`;

export const ModalInner = styled.div`
    max-width: 720px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    gap: 40px;
    box-sizing: border-box;
    padding-bottom: 24px;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 32px;
    }
`;

export const BackButton = styled.button`
    border: none;
    background: transparent;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: -0.34px;
    color: ${Colors.galBlack100};
    width: fit-content;

    &:hover {
        opacity: 0.7;
    }
`;

export const ModalTitle = styled.h1`
    margin: 0;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    letter-spacing: -0.6px;
    color: ${Colors.galBlack100};

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 24px;
        line-height: 30px;
    }
`;

export const SectionBlock = styled(FlexBox)`
    flex-flow: column;
    gap: 24px;
    width: 100%;
`;

export const SectionHeading = styled.div`
    font-size: 20px;
    line-height: 25px;
    font-weight: 600;
    letter-spacing: -0.4px;
    color: ${Colors.galBlack100};
`;

export const RadioList = styled(FlexBox)`
    flex-flow: column;
    gap: 16px;
    width: 100%;

    .radio-button--label {
        font-size: 17px;
        line-height: 22px;
        color: ${Colors.galBlack100};
    }
`;

export const VotingLabel = styled.div`
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: -0.3px;
    color: ${Colors.galBlack47};
    margin-bottom: 12px;
`;

export const ChipList = styled(FlexBox)`
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
`;

export const TeacherChip = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    background: ${Colors.galBlack5};
    border-radius: 3px;
    font-size: 15px;
    line-height: 20px;
    color: ${Colors.galBlack100};
`;

export const ChipRemove = styled.button`
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    font-size: 16px;
    line-height: 1;
    color: ${Colors.galBlack47};

    &:hover {
        color: ${Colors.galBlack100};
    }
`;

export const FooterBar = styled.div`
    flex-shrink: 0;
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    padding: 16px 0 24px;
    background: ${Colors.geoWhite100};
    border-top: 1px solid ${Colors.galBlack10};
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    box-sizing: border-box;
`;

export const FooterCancel = styled.button`
    border: none;
    background: transparent;
    padding: 10px 0;
    cursor: pointer;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: -0.34px;
    color: ${Colors.galBlack100};
    margin-right: auto;

    &:hover {
        opacity: 0.7;
    }

    &:disabled {
        opacity: 0.4;
        cursor: default;
    }
`;

export const FooterActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;
import styled from 'styled-components';
import { Colors, FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';

export const ModalRoot = styled.div`
    width: 100vw;
    height: 100%;
    min-height: 100%;
    align-self: stretch;
    background: ${Colors.geoWhite100};
    box-sizing: border-box;
    padding: 32px 48px 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (max-width: ${LayoutConst.screen.md}px) {
        padding: 48px 24px 0;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        padding: 40px 16px 0;
    }
`;

export const ModalInner = styled.div`
    max-width: 720px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    gap: 40px;
    box-sizing: border-box;
    padding-bottom: 24px;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 32px;
    }
`;

export const BackButton = styled.button`
    border: none;
    background: transparent;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: -0.34px;
    color: ${Colors.galBlack100};
    width: fit-content;

    &:hover {
        opacity: 0.7;
    }
`;

export const ModalTitle = styled.h1`
    margin: 0;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    letter-spacing: -0.6px;
    color: ${Colors.galBlack100};

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 24px;
        line-height: 30px;
    }
`;

export const SectionBlock = styled(FlexBox)`
    flex-flow: column;
    gap: 24px;
    width: 100%;
`;

export const SectionHeading = styled.div`
    font-size: 20px;
    line-height: 25px;
    font-weight: 600;
    letter-spacing: -0.4px;
    color: ${Colors.galBlack100};
`;

export const RadioList = styled(FlexBox)`
    flex-flow: column;
    gap: 16px;
    width: 100%;

    .radio-button--label {
        font-size: 17px;
        line-height: 22px;
        color: ${Colors.galBlack100};
    }
`;

export const VotingLabel = styled.div`
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: -0.3px;
    color: ${Colors.galBlack47};
    margin-bottom: 12px;
`;

export const ChipList = styled(FlexBox)`
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
`;

export const TeacherChip = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    background: ${Colors.galBlack5};
    border-radius: 3px;
    font-size: 15px;
    line-height: 20px;
    color: ${Colors.galBlack100};
`;

export const ChipRemove = styled.button`
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    font-size: 16px;
    line-height: 1;
    color: ${Colors.galBlack47};

    &:hover {
        color: ${Colors.galBlack100};
    }
`;

export const FooterBar = styled.div`
    flex-shrink: 0;
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    padding: 16px 0 24px;
    background: ${Colors.geoWhite100};
    border-top: 1px solid ${Colors.galBlack10};
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    box-sizing: border-box;
`;

export const FooterCancel = styled.button`
    border: none;
    background: transparent;
    padding: 10px 0;
    cursor: pointer;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: -0.34px;
    color: ${Colors.galBlack100};
    margin-right: auto;

    &:hover {
        opacity: 0.7;
    }

    &:disabled {
        opacity: 0.4;
        cursor: default;
    }
`;

export const FooterActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;
